module.exports = __webpack_public_path__ + "static/media/edit-outline.853693a9.svg";